/* eslint-disable padding-line-between-statements */
import * as systemErrorActions from './system-error-actions';
import ErrorCode from '../../../server/lib/error/code';

const {
	validateIpFailedAction,
} = systemErrorActions;
const {
	// Ip
	IP_NOT_MATCH_ANY_ONE,
} = ErrorCode;

const IpErrors = [IP_NOT_MATCH_ANY_ONE];

const ipBlockChecker = errorCode => {
	const ipError = IpErrors.find(ipError => ipError.CODE === errorCode);

	if (ipError) {
		return validateIpFailedAction();
	}
};

export {
	systemErrorActions,

	ipBlockChecker,
};
